module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/94b06fb716871f81bec601724e29a457.svg";